import { render, staticRenderFns } from "./RolesSetting.vue?vue&type=template&id=063634d1&scoped=true"
import script from "./RolesSetting.vue?vue&type=script&lang=js"
export * from "./RolesSetting.vue?vue&type=script&lang=js"
import style0 from "./RolesSetting.vue?vue&type=style&index=0&id=063634d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063634d1",
  null
  
)

export default component.exports